/**
 * @file ua相关判断
 */

const _ua = window?.navigator?.userAgent || '';

// 判断是否ios
export const isIOS = (ua?: string) => {
    return /(iPhone|iPod|iPad)/.test(ua || _ua);
};

// 判断是否安卓
export const isAndroid = (ua?: string) => {
    return /Android/.test(ua || _ua);
};

// 判断是否鸿蒙
export const isHarmony = (ua?: string) => {
    return /ArkWeb/.test(ua || _ua);
};

// 判断是否windows phone
export const isWindowsPhone = (ua?: string) => {
    return /(Windows Phone|IEMobile)/.test(ua || _ua);
};

// 判断是否移动端
export const isMobile = (ua?: string) => {
    const baseUa = ua || _ua;
    if (isAndroid(baseUa) || isIOS(baseUa) || isHarmony(baseUa) || isWindowsPhone(baseUa)) {
        return true;
    }
    return false;
};
